import IPadSettings from './IPadSettings'

export default IPadSettings
